import { render, staticRenderFns } from "./MatingProgram.vue?vue&type=template&id=0707e8d4&scoped=true&"
import script from "./MatingProgram.vue?vue&type=script&lang=js&"
export * from "./MatingProgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0707e8d4",
  null
  
)

export default component.exports